<script setup>
defineProps({
  aisText: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="ais-info-board">
    <span>{{ aisText }}</span>
  </div>
</template>